// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch--37SUz","switchBox":"switchBox--ouDaN","switchText":"switchText--UTXAs","profitModal":"profitModal--L5Ojs","profitForm":"profitForm--UeAai"};